import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import EagerDatableDesignEtat from 'components/Commun/Table/EagerDatableDesignEtat';
import { statutsArmes } from '../../../../../components/arme/statuts/StatutsArmes';

const RatelierArmeImpression = ({ isLoading, data, setArmesSelectionnees }) => {
    const tableauConfig = [
        { field: 'numeroEncodage', header: "Numéro d'encodage", sortable: true, filter: true },
        { field: 'numeroCarcasse', header: 'Numéro de série', sortable: true, filter: true },
        { field: 'type', header: 'Type', sortable: true, filter: true },
        { field: 'marque', header: 'Marque', sortable: true, filter: true },
        { field: 'modele', header: 'Modèle', sortable: true, filter: true },
        { field: 'calibreCanon', header: 'Calibre Canon 1', sortable: true, filter: true },
        { field: 'calibreCanonDeux', header: 'Calibre Canon 2', sortable: true, filter: true },
        { field: 'classementFrancais', header: 'Classement', sortable: true, filter: true },
        {
            field: 'statut',
            header: 'Statut',
            sortable: true,
            filter: true,
            filterType: 'list',
            filterList: statutsArmes,
        },
    ];

    const selectionListener = (selectionList) => {
        setArmesSelectionnees([...selectionList]);
        return false;
    };

    return (
        <div>
            <EagerDatableDesignEtat
                columns={tableauConfig}
                records={data && data.records ? data.records : []}
                nombreTotal={data && data.nombreTotal}
                clearFiltersButton
                isLoading={isLoading}
                areLignesSelectionnables
                selectionListener={selectionListener}
                rechercheIcon
            />
        </div>
    );
};

RatelierArmeImpression.propTypes = {
    data: PropTypes.shape({
        nombreTotal: PropTypes.number.isRequired,
        records: PropTypes.array,
    }),
    isLoading: PropTypes.bool,
    setArmesSelectionnees: PropTypes.array,
};

export default connect()(RatelierArmeImpression);
